import { render } from "./InfoPane.vue?vue&type=template&id=f6d33e94"
import script from "./InfoPane.vue?vue&type=script&lang=js"
export * from "./InfoPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__